module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../node_modules/happypack/loader.js?id=jsx!./ThematicHjView.js"));
	}, "ThematicView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=ThematicView!./src/pages/Learn/Thematic/ThematicHjView.js
// module id = 1736
// module chunks = 418